
export enum PARKING {
  None= 0
}



// WEBPACK FOOTER //
// ./src/app/shared/model/parking.enum.ts